export default __webpack_public_path__ + "static/media/Path3433.7911723f.svg";